module.exports = __webpack_public_path__ + "static/media/2021_50k.dc669c00.gpx";